<template>
  <v-app dark>
    <notification/>
    <router-view/>
  </v-app>
</template>

<script>
import Notification from "./Notification.vue";

export default {
  name: "root",
  components: { Notification }
};
</script>



// WEBPACK FOOTER //
// src/components/Root.vue